module.exports = __webpack_public_path__ + "img/advantage-item02.a54c8689.png";